import angular from "angular"

FormularioCrearRolesController.$inject = ["$scope", "$mdDialog", "saveCallback"]
function FormularioCrearRolesController($scope, $mdDialog, saveCallback) {
  var self = $scope

  self.isLoading = false

  self.confirm = function() {
    var rol = {
      name: self.name
    }

    // console.log(user);
    saveCallback(rol)
    self.cancelar()
  }

  self.cancelar = function() {
    $mdDialog.hide()
  }
}

angular
  .module("appModule")
  .controller("FormularioCrearRolesController", FormularioCrearRolesController)
